import service from '../config/axios.config';
import { addAlert } from './alerts.action';
import { setObjectiveLicences } from '../reducers/licencesSlice';

export const FETCH_EMPLOYEE_DATA = 'cx-ray/EMPLOYEE/FETCH';
export const EDIT_EMPLOYEE_LOGINNAME = 'cx-ray/EMPLOYEE/EDIT_LOGINNAME';
export const EDIT_EMPLOYEE_PASSWORD = 'cx-ray/EMPLOYEE/EDIT_PASSWORD';
export const EDIT_EMPLOYEE_LANGUAGE = 'cx-ray/EMPLOYEE/EDIT_LANGUAGE';

export const fetchEmployeeData = () => {
  return async dispatch => {
    const url = `/me`;

    try {
      const { data } = await service.get(url);
      dispatch(setObjectiveLicences(data.hasValidObjectiveManagementLicence));
      dispatch({
        type: FETCH_EMPLOYEE_DATA,
        payload: data
      });
      return data;
    } catch (error) {
      dispatch(
        addAlert({ message: error.message, severity: 'error' })
      );
    }
  };
};

export const editLoginName = loginName => {
  return async dispatch => {
    const url = `/me/loginName`;

    try {
      await service.put(url, { loginName });

      dispatch(
        addAlert({ message: 'settings.loginName.success', severity: 'success' })
      );
    } catch (error) {
      dispatch(
        addAlert({ message: 'settings.loginName.error', severity: 'error' })
      );
    }
  };
};

export const editPassword = ({ password, currentPassword }, callback) => {
  return async dispatch => {
    const url = `/me/password`;
    try {
      await service.put(url, { password, currentPassword });

      dispatch(
        addAlert({ message: 'settings.password.success', severity: 'success' })
      );
      callback();
    } catch (error) {
      error.status === 403 ?
        dispatch(
          addAlert({ message: 'settings.password.currentPasswordError', severity: 'error' })
        ) :
        dispatch(
          addAlert({ message: 'settings.password.error', severity: 'error' })
        );
    }
  };
};

export const editLanguage = language => {
  return async dispatch => {
    const url = `/me/language`;

    try {
      const { data } = await service.put(url, { language });

      dispatch({
        type: EDIT_EMPLOYEE_LANGUAGE,
        payload: data
      });
      dispatch(
        addAlert({ message: 'settings.language.success', severity: 'success' })
      );
    } catch (error) {
      dispatch(
        addAlert({ message: 'settings.language.error', severity: 'error' })
      );
    }
  };
};
